import i18next from 'i18next'

import { mapGetters } from 'vuex'

/**
 * add reactivity to locale and translation method
 */
export const userMixin = {
  methods: {
    fullName (firstName, lastName) {
      if (firstName && lastName) {
        return firstName + ' ' + lastName
      } else {
        return ''
      }
    }
  }
}
/**
 * add reactivity to locale and translation method
 */
export const localeMixin = {
  computed: {
    ...mapGetters(['locale'])
  },
  mounted () {
    this.$watch('locale', (newVal, oldVal) => {
      this.$forceUpdate()
    })
  },
  methods: {
    $t (key, opts = {}) {
      return i18next.t(key, opts)
    },
    $tcapitalize (key, opts = {}) {
      const value = i18next.t(key, opts)
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    $tuppercase (key, opts = {}) {
      const value = i18next.t(key, opts)
      return value.toUpperCase()
    },
    $tlowercase (key, opts = {}) {
      const value = i18next.t(key, opts)
      return value.toLowerCase()
    },
    isTz12H (timezone) {
      if (timezone) {
        return timezone.startsWith('America') || timezone.startsWith('US') || timezone.startsWith('Canada') || timezone.startsWith('Australia')
      }
      return false
    },
    formatHour (date, timezone, withAMPM = false) {
      if (this.isTz12H(timezone)) {
        if (withAMPM) {
          return date.format('h:mm A').toLowerCase()
        } else {
          return date.format('h:mm')
        }
      } else {
        return date.format('HH:mm')
      }
    }
  }
}

/**
 * snackbars opening methods
 */
export const snackbarMixin = {
  methods: {
    openSnackbarSuccess (message, options = {}) {
      const mergedOpt = Object.assign(
        {},
        {
          closeButtonText: 'Ok',
          timeout: 4000
        },
        options
      )

      this.$root.$children[0].$refs.snackbar.open(
        message || 'Success',
        mergedOpt
      )
    },
    openSnackbarError (message, options = {}) {
      const mergedOpt = Object.assign(
        {},
        {
          context: 'error',
          closeButtonText: 'Retry',
          timeout: 60000
        },
        options
      )

      this.$root.$children[0].$refs.snackbar.open(
        message || this.$t('snackBar.wentWrong'),
        mergedOpt
      )
    },
    openSnackbarCustom (message, options = {}) {
      this.$root.$children[0].$refs.snackbar.open(message, options)
    }
  }
}

export const stringMixin = {
  methods: {
    /**
     *
     * @param value to trim, like 'value to trim'
     * @param maxCharacters like 10
     * @returns {string} like 'value to t...'
     */
    trimEllipsis (value, maxCharacters) {
      if (!value) return value
      const regex = /(<([^>]+)>)/ig
      if (value.length <= maxCharacters) {
        return value.replace(regex, '').replace('Inbox---', '').replace('Inbox - ', '').replace('Gmelius/SharedLabel/', '')
      } else {
        return value.replace(regex, '').replace('Inbox---', '').replace('Inbox - ', '').replace('Gmelius/SharedLabel/', '').substring(0, maxCharacters - 1).concat('...')
      }
    }
  }
}

export const isMobileMixin = {
  computed: {
    isMobile () {
      let result = false
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          result = true
          break
        case 'sm':
          result = true
          break
        case 'md':
          result = false
          break
        case 'lg':
          result = false
          break
        case 'xl':
          result = false
          break
      }
      return result
    }
  }
}
